export default "__VITE_PUBLIC_ASSET__1faeb6ea__"